import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { checkStoreState, setInitialStoreState } from '../../../../../common';
import { combineLatest, Observable } from 'rxjs';
import { HandlingUnitNotificationsFacade } from './handling-unit-notifications.facade';
import { switchMap } from 'rxjs/operators';
import { HandlingUnitItemFacade } from '../handling-unit-item.facade';

@Injectable({
  providedIn: 'root',
})
export class HandlingUnitNotificationsGuard {
  constructor(
    private handlingUnitNotificationsFacade: HandlingUnitNotificationsFacade,
    private handlingUnitItemFacade: HandlingUnitItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([
      this.handlingUnitItemFacade.deliveryNoteNumber$,
      this.handlingUnitItemFacade.handlingUnitNumber$,
    ]).pipe(
      switchMap(([deliveryNoteNumber, handlingUnitNumber]: [string, string]) =>
        checkStoreState(this.handlingUnitNotificationsFacade, {
          deliveryNoteNumber,
          handlingUnitNumber,
        }),
      ),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.handlingUnitNotificationsFacade);
  }
}
